<template>
  <section v-show="sidebarCurrentPanel === 'viewmode'"  class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
    <div class="kp-modular-tab pt-page no-fade pt-page-current">
      <header class="kp-modular-title">{{ $t('general.labels.themes') }}</header>
      <div class="submenu-content sub-color">
        <type-header></type-header>
        <viewmode-automatic></viewmode-automatic>
        <viewmode-click></viewmode-click>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import TypeHeader from './Header.vue';
import ViewmodeAutomatic from './Automatic.vue';
import ViewmodeClick from './Click.vue';

export default {
  components: {
    TypeHeader,
    ViewmodeAutomatic,
    ViewmodeClick,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?f2f41ec0
 **/